export default __webpack_public_path__ + "static/media/8 RADIO EQUIPMENT.e2da41dd.png";